var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgApply(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.4194 0.719876C17.3629 1.0566 17.3018 1.39332 17.2521 1.73234C17.0169 3.32663 16.7817 4.92091 16.5488 6.5152C16.3272 8.02015 16.1078 9.52282 15.8884 11.0278C15.7324 12.0838 15.5809 13.1397 15.4203 14.1934C15.3593 14.592 15.0472 14.7867 14.6741 14.6584C12.1616 13.7903 9.65145 12.9198 7.13902 12.0494C7.13449 12.0494 7.12997 12.0425 7.10283 12.0265C9.53612 9.05552 11.9694 6.08685 14.4004 3.12047L14.3688 3.0884C14.2557 3.1869 14.1404 3.2831 14.0273 3.3816C11.0241 5.98377 8.02097 8.58365 5.02007 11.1881C4.93413 11.2637 4.86403 11.2683 4.76227 11.2339C3.31722 10.73 1.87217 10.2283 0.424866 9.73126C0.180633 9.64651 0.0223338 9.49304 0.00198099 9.22961C-0.0183718 8.9639 0.119575 8.78981 0.347978 8.6707C4.6198 6.41212 8.88935 4.15355 13.1612 1.89268C14.2693 1.30628 15.3796 0.719876 16.4877 0.133471C16.9377 -0.104756 17.1752 -0.0314551 17.4172 0.41293V0.722166L17.4194 0.719876Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.54354 13.0667C7.45497 13.3953 8.34555 13.7196 9.2549 14.046C9.12767 14.2291 9.01087 14.3968 8.89408 14.5644C8.42063 15.246 7.94719 15.9254 7.47583 16.607C7.35277 16.7834 7.20052 16.8959 6.9857 16.8717C6.70622 16.8408 6.5352 16.6246 6.53311 16.3004C6.53311 15.268 6.53311 14.2357 6.53311 13.2012C6.53311 13.1637 6.53728 13.1262 6.54145 13.0645L6.54354 13.0667Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApply);
export default __webpack_public_path__ + "static/media/apply.381652cf44589db88063d9db727780fc.svg";
export { ForwardRef as ReactComponent };